import { render, staticRenderFns } from "./uploadImgToOCR.vue?vue&type=template&id=6ad54271&scoped=true&"
import script from "./uploadImgToOCR.vue?vue&type=script&lang=js&"
export * from "./uploadImgToOCR.vue?vue&type=script&lang=js&"
import style0 from "./uploadImgToOCR.vue?vue&type=style&index=0&id=6ad54271&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad54271",
  null
  
)

component.options.__file = "uploadImgToOCR.vue"
export default component.exports